import { Autocomplete as MuiAutocomplete } from "@mui/material";
import { styled } from "@mui/system";

import { PrintOnlyTypography } from "components/formFields/PrintOnlyTypography";

const PrintHiddenAutocomplete = styled(MuiAutocomplete)({
  "@media print": { display: "none" },
});

export function PrintFriendlyAutocomplete(props) {
  const { value } = props;
  return (
    <>
      <PrintOnlyTypography>{value?.name}</PrintOnlyTypography>
      <PrintHiddenAutocomplete {...props} />
    </>
  );
}
